// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaLinkedin_root__UMU0R"};